import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { AUTH_QUERY_KEYS, AUTH_ROUTES } from '../constants';
import { authService } from '../services';
import { useAuthStore } from './use-auth-store';

/**
 * Mutation de login social: envia o ID token do Google, que a API troca por
 * um cookie de sessao. O usuario vem de /me, ja no formato publico da API.
 */
export function useLoginWithGoogle() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const setUser = useAuthStore((state) => state.setUser);

  return useMutation({
    mutationFn: (credential: string) => authService.loginWithGoogle(credential),

    onSuccess: async () => {
      const { user } = await authService.me();

      setUser(user);
      await queryClient.invalidateQueries({ queryKey: AUTH_QUERY_KEYS.me });
      navigate(AUTH_ROUTES.DASHBOARD, { replace: true });
    },
  });
}
